export const fetchAuthUrlWithService = (baseUrl, destination) => {
    if (typeof window === 'object') {
        const { pathname } = window.location;
        const segments = pathname.split('/').filter(Boolean);
        // Derive the current app path (the segment after the locale) so we preserve
        // custom app paths like `list-one-key` instead of hardcoding `list`.
        const appPath = segments.length > 1 ? segments[1] : 'list';
        const servicePath = `/${appPath}/validate-ticket?origin=${encodeURIComponent(destination)}`;
        const service = `${window.location.protocol}//${window.location.host}${servicePath}`;
        const serviceComponent = `service=${encodeURIComponent(service)}`;
        // Add as a first or trailing query parameter
        // depending on if baseUrl already contains a query parameter
        return baseUrl.indexOf('?') !== -1
            ? `${baseUrl}&${serviceComponent}` : `${baseUrl}?${serviceComponent}`;
    }
    return '';
};

export default {
    fetchAuthUrlWithService
};
